import axios from 'axios';

// Configura Axios con la URL base desde el archivo .env
const instance = axios.create({
  //baseURL: process.env.VUE_APP_API_URL, //PRODUCCION
  //baseURL: process.env.VUE_APP_API_URL_DEV, //DEVELOPMENT ALFA
  //baseURL: process.env.VUE_APP_API_URL_BETA, //BETA
  //baseURL: process.env.VUE_APP_API_URL_ALFA, //ALFA
  baseURL: process.env.VUE_APP_API_URL_PRO, //CONTINGENCIA PRO
});

export default instance;
